enum Path {
  CoverPage = '/contents/:contentId',
  ContentsPage = '/contents/main/:contentId',
}

export default Path;
